import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import ProductsServices from './product_services';

export const CreateProduct = createAsyncThunk(
  'product/create_product',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await ProductsServices.CreateProduct(requestData);

      // window.location.href = '/dashboard/product';

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const UploadProductImages = createAsyncThunk(
  'product/product_images',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await ProductsServices.uploadProductImages(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const UploadProductThu = createAsyncThunk(
  'product/product_thu',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await ProductsServices.uploadProductThu(requestData);

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const GetAllProduct = createAsyncThunk(
  'product/get_all_product',
  async (payload, thunkAPI) => {
    try {
      let response = await ProductsServices.getAllProduct(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetAllProductById = createAsyncThunk(
  'product/get_all_product_by_id',
  async (payload, thunkAPI) => {
    try {
      let response = await ProductsServices.getAllProductById(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const DeleteProduct = createAsyncThunk(
  'product/delete_product',
  async (payload, thunkAPI) => {
    try {
      let response = await ProductsServices.DeleteProduct(payload);

      return response;
    } catch (error) {
      toast(error.message);
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const GetSingleProductDetails = createAsyncThunk(
  'product/get_single_product',
  async (payload, thunkAPI) => {
    try {
      let response = await ProductsServices.getSingleProductDetails(payload);

      return response;
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const EditProductDetail = createAsyncThunk(
  'product/edit_product',
  async (requestData, thunkAPI) => {
    try {
      const delivered = await ProductsServices.EditProduct(requestData);

      // window.location.href = '/dashboard/product';

      return delivered;
    } catch (e) {
      toast(e.message);
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const GetAllProductCount = createAsyncThunk(
  'product/getAllProductCount',
  async (_, thunkAPI) => {
    try {
      const delivered = await ProductsServices.getAllProductCount();

      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

export const SearchForProductsByTitle = createAsyncThunk(
  'product/searchForProductsByTitle',
  async (payload, thunkAPI) => {
    try {
      const delivered = await ProductsServices.SearchForProductByTitle(payload);

      return delivered;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);
